// Sección de orígenes de prospección en Admin (Dimensiones)

import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const OrigenesProspeccionAdmin = () => {
    const [origenes, setOrigenes] = useState([]);
    const [newOrigen, setNewOrigen] = useState("");

    useEffect(() => {
        fetchOrigenes();
    }, []);

    const fetchOrigenes = async () => {
        try {
            const res = await fetch(`${BASE}/buscar_origenes_prospeccion.php`);
            const data = await res.json();
            setOrigenes(data);
        } catch {
            toast.error("Error al cargar orígenes");
        }
    };

    const handleAdd = async () => {
        const nombre = newOrigen.trim();
        if (!nombre) return;
        try {
            const res = await fetch(`${BASE}/guardar_origen_prospeccion.php`, {
                method: "POST",
                body: new URLSearchParams({ nombre }),
            });
            const data = await res.json();
            if (data.ok) {
                toast.success("Origen agregado");
                setNewOrigen("");
                fetchOrigenes();
            } else {
                toast.error(data.error || "Error al agregar");
            }
        } catch {
            toast.error("Error de conexión");
        }
    };

    const handleEdit = async (o) => {
        const newName = prompt("Nuevo nombre para el origen:", o.nombre);
        if (!newName || newName.trim() === o.nombre) return;
        try {
            const res = await fetch(`${BASE}/editar_origen_prospeccion.php`, {
                method: "POST",
                body: new URLSearchParams({ id: o.id, oldName: o.nombre, newName: newName.trim() }),
            });
            const data = await res.json();
            if (data.ok) {
                toast.success("Origen actualizado (y cascadeado en prospectos)");
                fetchOrigenes();
            } else {
                toast.error(data.error || "Error al editar");
            }
        } catch {
            toast.error("Error de conexión");
        }
    };

    const handleDelete = async (o) => {
        if (!window.confirm(`¿Eliminar el origen "${o.nombre}"?`)) return;
        try {
            const res = await fetch(`${BASE}/eliminar_origen_prospeccion.php`, {
                method: "POST",
                body: new URLSearchParams({ id: o.id }),
            });
            const data = await res.json();
            if (data.ok) {
                toast.success("Origen eliminado");
                fetchOrigenes();
            } else {
                toast.error(data.error || "Error al eliminar");
            }
        } catch {
            toast.error("Error de conexión");
        }
    };

    return (
        <section>
            <div className="container">
                <div className="container-addbar" style={{ marginTop: "40px" }}>
                    <input
                        type="text"
                        value={newOrigen}
                        onChange={(e) => setNewOrigen(e.target.value)}
                        placeholder="Nuevo origen de prospección"
                        onKeyDown={(e) => e.key === "Enter" && handleAdd()}
                    />
                    <button className="searchbar_form_submit" onClick={handleAdd}>
                        Agregar
                    </button>
                </div>

                <div className="categories-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Origen</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {origenes.map((o) => (
                            <tr key={o.id}>
                                <td>{o.id}</td>
                                <td>{o.nombre}</td>
                                <td>
                                    <div style={{ display: "flex", gap: "1px" }}>
                                        <FaRegEdit
                                            className="action-icon"
                                            onClick={() => handleEdit(o)}
                                            style={{
                                                display: "flex", justifyContent: "center", alignItems: "center",
                                                width: "32px", height: "32px", backgroundColor: "#4893e9",
                                                borderRadius: "5px", cursor: "pointer", marginRight: "7px",
                                            }}
                                        />
                                        <MdDelete
                                            className="action-icon"
                                            onClick={() => handleDelete(o)}
                                            style={{
                                                display: "flex", justifyContent: "center", alignItems: "center",
                                                width: "32px", height: "32px", backgroundColor: "#D9534F",
                                                borderRadius: "5px", cursor: "pointer",
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </div>
            </div>
        </section>
    );
};

export default OrigenesProspeccionAdmin;
